import { SvgIcon, SvgIconProps } from '@mui/material';

export const RoleIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 20 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M13.49 18a1 1 0 01-1-1v-1.98H9.819a1 1 0 01-1-1V5.248H6.6v2.1a1 1 0 01-1 1H1a1 1 0 01-1-1v-5.51a1 1 0 011-1h4.6a1 1 0 011 1v1.98h5.89v-1.98a1 1 0 011-1h4.579a1 1 0 011 1v5.508a1 1 0 01-1 1H13.49a1 1 0 01-1-1v-2.1h-2.24v8.343h2.24v-2.1a1 1 0 011-1h4.579a1 1 0 011 1v5.508a1 1 0 01-1 1L13.492 18zm.43-11.084h3.718V2.268H13.92v4.648zm0 9.654h3.718v-4.648H13.92v4.648zM1.43 6.916h3.742V2.268H1.43v4.648z'
          fill='currentColor'
        />
      </svg>
    </SvgIcon>
  );
};
